export default __webpack_public_path__ + "static/linkedin-cdeb948f8ab8a053fc0b0abfc3120c48.png";